<template>
    <div
        class="product-base-info"
    >
        <h3 class="row-header">
            城市无差异信息
        </h3>
        <!-- FormRender是物料库表单组件，支持表单项动态渲染，编辑和详情模式，支持自定义插槽，尝试使用这个组件 -->
        <form-render
            v-if="haveInit"
            ref="noDiffForm"
            :data="form"
            :fields="getFields(this)"
            :rules="rules"
            :type="mode"
            :span="24"
            width="130px"
            class="max-width-750 w-full"
        >
            <!-- 条形码 -->
            <template slot="skuCodeList">
                <!-- from 表示提报页面引用 -->
                <code-list
                    ref="codeList"
                    from="createNewProduct"
                    :category-id="categoryId"
                    :bg-category-id="bgCategoryId"
                    :show-city-list="false"
                    :data="form.skuCodeList"
                    :package-type="createInfoModel.packageType"
                    :disabled="MixinJudgeRejectedAttrsDisabled('skuCodeList')"
                    :focus-attr-data="focusAttrData"
                />
            </template>
            <template slot="weight">
                <el-input
                    v-model="form.weight"
                    :controls="false"
                    :disabled="MixinJudgeRejectedAttrsDisabled('weight')"
                    style="width:460px"
                />
                <FocusTag v-if="focusAttrData.weight" />
            </template>
            <template slot="storageTemperatureLevel">
                <xx-select
                    v-if="mode === 'edit'"
                    v-model="form.storageTemperatureLevel"
                    dic-code="special:product:newsell_storageTemperatureLevel"
                    :disabled="MixinJudgeRejectedAttrsDisabled('storageTemperatureLevel')"
                    @change="(val) => {
                        if (val !== changWenValue) form.storageTemperatureLevelRemark = null;
                    }"
                />
                <FocusTag v-if="mode === 'edit' && focusAttrData.storageTemperatureLevel" />
                <div v-if="mode === 'edit' && recommendValueObj.storageTemperatureLevel">
                    <mc-tag
                        theme="green"
                        type="pure"
                    >
                        推荐
                    </mc-tag>
                    {{ recommendValueObj.storageTemperatureLevelName }}
                    <mc-button
                        v-if="!MixinJudgeRejectedAttrsDisabled('storageTemperatureLevel')"
                        type="text"
                        size="small"
                        @click="handleUseRecommendValue(['storageTemperatureLevel'])"
                    >
                        使用推荐
                    </mc-button>
                </div>
                <xx-enum-text
                    v-if="mode === 'detail'"
                    v-model="form.storageTemperatureLevel"
                    dic-code="special:product:newsell_storageTemperatureLevel"
                />
                <FocusTag v-if="mode === 'detail'&& focusAttrData.storageTemperatureLevel" />
            </template>
            <template slot="importFlag">
                <xx-radio-group
                    v-if="mode === 'edit'"
                    v-model="form.importFlag"
                    :list="COMMON_DIC_CODE"
                    :disabled="MixinJudgeRejectedAttrsDisabled('importFlag')"
                />
                <FocusTag v-if="mode === 'edit' && focusAttrData.importFlag" />
                <div v-if="mode === 'edit' && COMMON_DIC_CODE[recommendValueObj.importFlag]">
                    <mc-tag
                        theme="green"
                        type="pure"
                    >
                        推荐
                    </mc-tag>
                    {{ recommendValueObj.importFlagName }}
                    <mc-button
                        v-if="!MixinJudgeRejectedAttrsDisabled('importFlag')"
                        type="text"
                        size="small"
                        @click="handleUseRecommendValue(['importFlag'])"
                    >
                        使用推荐
                    </mc-button>
                </div>
                <span v-if="mode === 'detail'">
                    {{ isMap[form.importFlag] }}
                </span>
                <FocusTag v-if="mode === 'detail' && focusAttrData.importFlag" />
            </template>
            <!-- 商品长宽高 -->
            <template
                slot="productSize"
            >
                <el-row
                    class="product-size"
                    :gutter="10"
                >
                    <el-col :span="8">
                        <xx-form-item
                            prop="length"
                            :rules="rules.length"
                        >
                            <el-input
                                v-model="form.length"
                                type="number"
                                :disabled="MixinJudgeRejectedAttrsDisabled('length')"
                                placeholder="请输入"
                            >
                                <template slot="prepend">
                                    长
                                </template>
                            </el-input>
                        </xx-form-item>
                    </el-col>
                    <el-col :span="8">
                        <xx-form-item
                            prop="width"
                            :rules="rules.width"
                        >
                            <el-input
                                v-model="form.width"
                                type="number"
                                :disabled="MixinJudgeRejectedAttrsDisabled('width')"
                                placeholder="请输入"
                            >
                                <template slot="prepend">
                                    宽
                                </template>
                            </el-input>
                        </xx-form-item>
                    </el-col>
                    <el-col :span="8">
                        <xx-form-item
                            prop="height"
                            :rules="rules.height"
                        >
                            <el-input
                                v-model="form.height"
                                type="number"
                                :disabled="MixinJudgeRejectedAttrsDisabled('height')"
                                placeholder="请输入"
                            >
                                <template slot="prepend">
                                    高
                                </template>
                            </el-input>
                        </xx-form-item>
                    </el-col>
                </el-row>
            </template>
        </form-render>
        <span
            v-if="mode === 'edit'"
            class="text-info"
        >下方字段没找到可用选项？<xx-link
            path="https://tt.sankuai.com/maicaishiyebu/create?cid=569&tid=5297&iid=24822"
        >
            前往申请
        </xx-link>，若无法操作申请，请联系采购，让采购申请</span>
        <!-- 扩展属性 -->
        <el-form
            class="max-width-750 w-full"
            label-width="130px"
            label-suffix="："
        >
            <NewExtAttrsWrap
                v-if="haveInit"
                ref="extAttrs"
                :category-id="categoryId"
                :bg-category-id="bgCategoryId"
                :selected-attr-list="form.skuBaseAttributes"
                :attr-type="ExtBusinessTypeMap.BASE_INFO"
                :recommend-attr-list="recommendValueObj.skuExtAttrList || []"
                :mode="mode"
                :dna-attrs-ids="hideExtAttr"
                :default-disabled="MixinJudgeRejectedAttrsDisabled('extAttrBaseInfo')"
                :default-attrs-id="isDiscountSku ? [{attrId:20018,id:55931}] : []"
                :is-discount-sku="isDiscountSku"
                :focused-marking-list="focusAttrData.extAttrList || []"
                show-value-image
                @selectedExtAttrList="onExtAttrSelected"
            />
        </el-form>
        <h3 class="row-header">
            城市有差异信息
        </h3>
        <xx-form
            ref="diffForm"
            :model="form"
            :rules="rules"
            label-width="130px"
            label-suffix="："
            size="small"
            class="max-width-750 w-full"
            :disabled="MixinJudgeRejectedFormDisabled"
        >
            <xx-form-item
                label="箱规"
                prop="cityBoxProps"
            >
                <!-- ref 用来标识业务内容，为后面组织传参做准备 -->
                <!-- 模式：每个业务组件都直接包含 add-container 组件，作为此业务组件的唯一 $children 内容 -->
                <xiang-gui
                    ref="cityBoxProps"
                    :data="form.cityBoxProps"
                    :all-city-list="allCityList"
                    :public-city-ids="publicCityIds"
                    :is-bulk="isSZ"
                    :can-delete-condition="canDeleteCondition"
                />
            </xx-form-item>
            <xx-form-item
                label="保质期"
                prop="guaranteePeriod"
            >
                <bao-zhi-qi
                    ref="guaranteePeriod"
                    :data="form.guaranteePeriod"
                    :all-city-list="allCityList"
                    :public-city-ids="publicCityIds"
                    :can-delete-condition="canDeleteCondition"
                    :guarantee-period-advice-number-day="guaranteePeriodAdviceNumberDay"
                    :flow-spec-by-category-info="flowSpecByCategoryInfo"
                />
            </xx-form-item>
        </xx-form>

        <h3
            v-if="!isMaterial"
            class="row-header"
        >
            其他售卖渠道信息补充
        </h3>
        <div
            v-if="!isMaterial"
            style="padding-left:50px"
        >
            <span style="color:#ff363f"> * </span> 外卖-商超商品信息：
            <McCard style="width:700px; margin:30px;">
                <sg-info
                    ref="sgInfoRef"
                    v-model="sgProps"
                    :skuName="createInfoModel.skuName || ''"
                />
            </McCard>
        </div>
    </div>
</template>

<script>
/**
 * 设计：
 *  整体获取 vm 中的数据的方式即【通过拿到 vm 的引用】-- 新品提报中每个步骤的 vm 是通过 baseModel.register 方法注册到 baseModel，
 *  而每个步骤中的子级组件获取引用即通过 ref 方式获得，这里要求尽量在每个步骤的组件下只设置一个层级，拆分层级太多带来获取引用方式的复杂度
 *  维护高于因为拆分组件所降解的复杂度（如有必要则可以通过 递归 的方式搜集各个子级的数据）。
 *
 *
*/

import { cloneDeep, debounce } from '@lsfe/tools';
import emitter from 'utils/emitter';
import Rules from '@lsfe/rules';
import FormRender from 'components/FormRender';
import NewExtAttrsWrap from 'components/NewExtAttrsWrap';
import { materialEnum, ExtBusinessTypeMap } from 'utils/dataMap';
import { getCategoryIdBylevel } from 'utils/category';
import MixinJudgeDnaAttrs from 'components/DnaAttrsWrap/mixin';
import XiangGui from './xianggui';
import BaoZhiQi from './baozhiqi';
// import ChuCangWenDu from './chucangwendu';
import CodeList from './codeList';

import { shared, createNewToken, productBaseInfoToken } from '../shareState';
import { getBaseModel } from '../baseModel';
import {
    getFields, initBoxProp, initBaozhiqi, initZhaiPeiWenDuan,
    changWenValue, COMMON_DIC_CODE, isMap, guaranteePeriodAttrIdMap,
    dnaAttrIdMap,
} from './config';
import MixinJudgeRejectedAttrsDisabled from '../mixins/rejectedDisabled';
import SgInfo from '../components/SgInfo';
import FocusTag from '../../../../components/FocusTag';

const baseModel = getBaseModel();

function isUndef(val) {
    return val === '' || val === null || val === undefined;
}

const initCodeItem = () => ({
    code: '',
    produceAreaId: '', // 产地
    produceAreaType: '', // 产地类型 没有产地：-1，城市：1，国家或省份：2
    mainCodeFlag: true, // 是否是主条形码
    manufactureId: '', // 生产者ID：更新时如果是新的生产商则传-1
    manufactureName: '',
    skuBaseCodeType: 1, // 商品条形码类型, 1 标准条码, 2 自编条码
});

export default {
    name: productBaseInfoToken,
    components: {
        FormRender,
        XiangGui,
        BaoZhiQi,
        // ChuCangWenDu,
        CodeList,
        NewExtAttrsWrap,
        SgInfo,
        FocusTag,
    },
    mixins: [emitter, MixinJudgeRejectedAttrsDisabled, MixinJudgeDnaAttrs],
    data() {
        return {
            form: {
                packageType: 1, // 销售形态 标品1，散装2
                unitId: '', // 单位
                unitName: '',
                consumeUnitName: '',
                // tipType: '',
                tipType: 0, // 该字段在页面隐藏，默认传“常规标品（展示日期）
                weight: '',
                length: '',
                width: '',
                height: '',
                importFlag: 0, // 是否进口标志, 0否, 1是
                inputTax: '', // 进项税
                skuCodeList: [
                    initCodeItem(),
                ], // 条形码
                cityBoxProps: [
                    initBoxProp(),
                ], // 箱规
                guaranteePeriod: [], // 保质期
                // 储存条件
                storageTemperatureLevel: '',
                storageTemperatureLevelRemark: '',
                deliveryTemperatures: [
                    initZhaiPeiWenDuan(),
                ], // 宅配温段
                skuBaseAttributes: [], // sku基础库扩展属性值
                sgProps: {},
            },
            rules: {
                skuCodeList: [
                    // Rules.isRequired('条形码必填'),
                ],
                unitId: [
                    Rules.isRequired('基础单位必填'),
                ],
                weight: [
                    Rules.isRequired('重量大于0并且不能超过50kg，不能超过3位小数'),
                    Rules.range({ min: 0, max: 50, le: false }, '重量大于0并且不能超过50kg，不能超过3位小数'),
                    Rules.decimalLen({ len: 3 }, '重量大于0并且不能超过50kg，不能超过3位小数'),
                ],
                length: [
                    Rules.decimalLen({ len: 1 }, '最多一位小数'),
                    Rules.range({
                        min: 0,
                        max: 200,
                        le: false,
                    }, '0< 当前值 <=200'),
                ],
                width: [
                    Rules.decimalLen({ len: 1 }, '最多一位小数'),
                    Rules.range({
                        min: 0,
                        max: 200,
                        le: false,
                    }, '0< 当前值 <=200'),
                ],
                height: [
                    Rules.decimalLen({ len: 1 }, '最多一位小数'),
                    Rules.range({
                        min: 0,
                        max: 200,
                        le: false,
                    }, '0< 当前值 <=200'),
                ],
                importFlag: [
                    Rules.isRequired('是否进口必填'),
                ],
                inputTax: [
                    Rules.isRequired('进项税必填'),
                ],
                cityBoxProps: [
                    Rules.lenRange({ min: 1 }, '请至少填一个'),
                ],
                guaranteePeriod: [
                    Rules.lenRange({ min: 1 }, '请至少填一个'),
                ],
                storageTemperatureLevel: [
                    Rules.isRequired('储存条件必选'),
                    Rules.notZero('储存条件必选'),
                ],
            },
            sgProps: {
                sgBgCategoryId: '',
                sgBgCategoryLevel: '',
                extAttrs: [],
            },
            existSkuEnable: false, // 展示不考虑 sku失效问题
            existSku: false, // 默认已存在sku，优先展示预览模式
            ExtBusinessTypeMap,
            createInfoModel: {}, // 提报信息数据
            existedCityIds: [], // 已存在SKU的城市id，不可编辑
            allCityList: (shared.allCityList || []).map((item) => ({ label: item.managementCityName, value: item.managementCityId })),
            haveInit: false,
            mode: 'edit',
            seafoodStateId: '',
            guaranteePeriodAdviceNumberDay: '',
            changWenValue,
            COMMON_DIC_CODE,
            isMap,
            recommendValueObj: {}, // 算法推荐值
            focusAttrData: {}, // c端展示重点属性
            flowSpecByCategoryInfo: {}, // 默认保质期信息
            isFirstEnforce: true,
            debounce,
        };
    },
    computed: {
        categoryId() {
            return this.createInfoModel.categoryId || '';
        },
        bgCategoryId() {
            return this.createInfoModel.bgCategoryId || '';
        },
        // 散装
        isSZ() {
            return this.createInfoModel.packageType === 2;
        },
        // 公共可选的城市id，就是新提报的销售城市
        publicCityIds() {
            return this.createInfoModel.cityIds || [];
        },
        // 原料
        isMaterial() {
            return this.createInfoModel.skuType === materialEnum;
        },
        getBgCategoryLevel1() {
            return getCategoryIdBylevel(this.bgCategoryId, 1, shared.bgCategoryTreeData);
        },
        cptTime() {
            return (val) => {
                switch (val) {
                    case 3: return '天';
                    case 2: return '月';
                    case 1: return '年';
                    case 0: return '无限制';
                    default: return null;
                }
            };
        },
        // 品牌id(dna属性或者固定属性)
        brandId() {
            const brandIdItem = (this.createInfoModel?.dnaAttrs || []).find((item) => item.attrId === dnaAttrIdMap.brandId);
            return brandIdItem?.selectedValues?.[0]?.id || this.createInfoModel.brandId;
        },
        // 是否进口(dna属性或者固定属性)
        importFlag() {
            const importFlagItem = (this.createInfoModel?.dnaAttrs || []).find((item) => item.attrId === dnaAttrIdMap.importFlag);
            return importFlagItem?.selectedValues?.[0]?.id || this.form.importFlag;
        },
        handlerGuaranteePeriod() {
            const bgCategoryId = this.createInfoModel.bgCategoryId;
            const {
                seafoodStateId, varietalId, brandId, importFlag,
            } = this;
            return {
                bgCategoryId,
                seafoodStateId,
                varietalId,
                brandId,
                importFlag,
            };
        },

        hideExtAttr() {
            const isProd = ['beta', 'staging', 'production'].includes(process.env.NODE_ENV);
            // 食用方法与口味改为扩展属性、并且 vss 端不展示食用方法字段
            const defaultHideExtAttr = isProd ? [20001] : [20326];
            const dnaExtAttrIds = this.MixinGetDnaExtAttrIds();
            return [...dnaExtAttrIds, ...defaultHideExtAttr];
        },

        // 是否是b货
        isDiscountSku() {
            const productType = this.createInfoModel.keyAttributes.find((item) => item.attrId === 20019);
            return productType && productType.selectedValues[0].id === 56365;
        },
    },
    watch: {
        // 后台,品牌, 海鲜状态发生变化要调用建议保质期接口
        handlerGuaranteePeriod: {
            handler(newV, oldV) {
                if (newV !== oldV) {
                    this.getGuaranteePeriod();
                }
            },
            deep: true, // 深度监听
        },
    },
    created() {
        baseModel.registerVM(this, productBaseInfoToken);
    },
    async activated() {
        if (shared.stepChangeType === 'next') {
            this.haveInit = false;
            try {
                await this.initState();
                this.queryRecommendValue();
                this.queryFocusAttr();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(error);
            } finally {
                this.haveInit = true;
                this.dispatch(createNewToken, 'page-loaded', true);
            }
        }
    },
    methods: {
        // created中只保留 确定只需要初始化一次的操作
        // 如果和前后页数据有联动，则都放到initState中，在activated中次执行
        // 主要处理回到上一步后更改数据，再次进入这步时的二次初始化
        async initState() {
            // 进入第二步，直接重新请求，这样可以避免一些不必要的判断，简化数据流
            const draft = await this.fetchNewCreateData(baseModel.models.applyId);
            // console.log(draft.skuBaseSection.guaranteePeriod, '第二页保质期为null的时候，我们才去给保质期赋值默认值，');

            baseModel.setData(draft);
            const productModel = baseModel.initProductBaseInfo;
            // TODO 直接读接口数据，不需要从baseModel.models里面取值
            this.createInfoModel = baseModel.models.applyInfoSection || {};
            this.existedCityIds = shared.existedCityIds;


            // 城市有差异字段
            // const hasDiffProps = ['cityBoxProps', 'guaranteePeriod', 'storageTemperatures'];
            const hasDiffProps = ['recipes', 'cityBoxProps', 'guaranteePeriod'];
            if (productModel) {
                let newCityIds = [];
                Object.keys(productModel).forEach((key) => {
                    if (hasDiffProps.includes(key)) {
                        if (productModel[key] && productModel[key].length) {
                            this.form[key] = productModel[key];
                        }
                        /**
                         * 处理 已有SKU，城市有差异信息，提报城市选中状态
                         * 因为后端会将已有SKU信息merge，所以 cityIds字段里面包含已存在城市 和 新提报城市 [ exisedIds, selectedIds ]，需要把 exisedIds分离出来，
                         * 为每个item新增existedIds属性，用来初始化已存在城市不可编辑
                         *
                         * 已有sku和新增sku 都适用，只是新增sku的existedids为空
                         */
                        newCityIds = this.publicCityIds;
                        this.form[key].forEach((item) => {
                            // 取交集，得到已有城市id
                            const existedIds = window._.intersection(item.cityIds || [], this.existedCityIds);
                            // 取差集，得到新提报的城市id
                            const selectedCityIds = window._.xor(item.cityIds, existedIds);
                            // 用新提报城市id 和 当前selectedCityIds 取交集，得到的结果重新赋值给cityIds
                            // 取交集是为了判断出前后没有变化的城市id有哪些，这些继续保留。剩余的id，就是前后对比发生变化的，这些被清理
                            const cityIds = window._.intersection(newCityIds, selectedCityIds);
                            item.existedIds = existedIds;
                            item.cityIds = cityIds;
                        });
                    } else {
                        if (!isUndef(productModel[key])) this.form[key] = productModel[key];
                    }
                });
            }

            this.form.storageTemperatureLevelRemark = this.form.storageTemperatureLevelRemark === 0 ? '' : this.form.storageTemperatureLevelRemark;
            // 初始化 城市无差异信息中的条形码
            this.form.skuCodeList = this.form.skuCodeList.map((item) => ({
                ...item,
                code: item.code || shared.similarCspuInfo?.codeList?.[0]?.code || '',
            }));
            if (this.form && this.form.sgProps) {
                const { sgBgCategoryId, sgBgCategoryLevel, extAttrs } = this.form.sgProps;
                // 根据属性值类型，映射为内部的值类型 闪购 1:单选 2:多选 3:input 买菜 3:单选 4:多选 1和2: input
                this.sgProps = {
                    sgBgCategoryId: sgBgCategoryId || '',
                    sgBgCategoryLevel,
                    extAttrs: (extAttrs || []).map((item) => {
                        const valueTypeMapping = { 1: 3, 2: 4, default: 1 };
                        const valueType = valueTypeMapping[item.attrValueType] || valueTypeMapping.default;
                        return {
                            attrId: item.attrId,
                            attrName: item.attrName,
                            valueType,
                            required: item.need === 1,
                            sgExtAttrValues: item.sgExtAttrValues || [],
                        };
                    }),
                };
                // 这里获取通过sgBgCategoryId重新获取下扩展属性
                if (this.$refs.sgInfoRef) {
                    this.$refs.sgInfoRef.querySgBgCategoryExtAttr(sgBgCategoryId);
                    this.$refs.sgInfoRef.queryRecommendValueForSgProduct(sgBgCategoryId, this.createInfoModel.skuName);
                }
            }
            // 兜底逻辑：
            // 清理多余数据，保证参数准确
            this.cleanProductInfo();
        },

        // 根据flowId重新请求数据
        async fetchNewCreateData(applyId) {
            const draftData = await this.$service.fetchNewSellDetail({ applyId });
            return draftData;
        },
        // 获取固定属性、扩展属性的推荐值
        async queryRecommendValue() {
            if (!this.createInfoModel.skuName) return; // 商品名称是必填参数
            const params = {
                skuName: this.createInfoModel.skuName,
                bgCategoryId: this.createInfoModel.bgCategoryId,
            };
            const res = await this.$hPost('/api/vss/shepherd/selection/ClueSkuQueryTService/recommendMcAttrByAIAndData', params)
                .catch(() => ({}));
            this.recommendValueObj = res.recommendMcSku || {};
        },
        // 获取重点属性
        async queryFocusAttr() {
            if (!this.createInfoModel.bgCategoryId) return;
            const res = await this.$hPost('/api/vss/shepherd/ProductAttrDescQueryTService/queryAttrDescByBgCategoryId', { bgCategoryId: this.createInfoModel.bgCategoryId }).catch(() => ({}));

            this.focusAttrData = {
                extAttrList: (res.extAttrDesc || []).filter((item) => item.appDisplay).map((item) => item.attrId),
            };
            (res.fixedAttrDesc || []).forEach((item) => {
                this.focusAttrData[item.code] = item.appDisplay;
            });
        },
        handleUseRecommendValue(props = []) {
            props.forEach((item) => {
                this.form[item] = this.recommendValueObj[item];
            });
        },
        // 每个 VM 通过此方法对外暴露自己的数据模式
        // TODO: 需要依赖：1. refs 的名称  2. 确保每个 ref 对应的组件的 $children 只有一个（即这些 refs 组件必须是对 addContainer 的包装）  这两部分依赖需要设计避免误用。
        // 也不必在这里暴露一个内部方法，因为 refs 和 $children 的模式都是确定的，在这里只是为了确保内聚性。
        // 外部调用
        getVMPostData() {
            const excludeRefs = ['noDiffForm', 'extAttrs', 'diffForm', 'codeList', 'sgInfoRef'];
            Object.keys(this.$refs).forEach((ref) => {
                if (!excludeRefs.includes(ref)) {
                    this.form[ref] = this.$refs[ref] ? this.$refs[ref].getData() : [];
                }
            });
            return cloneDeep(this.form);
        },
        // 获取表单
        getFields(vm) {
            return getFields(vm);
        },
        // 扩展属性相关
        onExtAttrSelected(extAttrList) {
            this.form.skuBaseAttributes = extAttrList;
            // 过虑出海鲜状态和品种属性
            const varietalItem = (extAttrList || []).find((item) => guaranteePeriodAttrIdMap.varietal === item.attrId);
            const seafoodTypeItem = (extAttrList || []).find((item) => guaranteePeriodAttrIdMap.varietal === item.attrId);
            if (varietalItem?.selectedValues?.length); this.varietalId = varietalItem?.selectedValues?.[0]?.id;
            if (seafoodTypeItem?.selectedValues?.length) this.seafoodStateId = seafoodTypeItem?.selectedValues?.[0]?.id;
        },
        // 根据后台类目/品牌/海鲜状态查对应的保质期
        getGuaranteePeriod: debounce(async function () {
            this.guaranteePeriodAdviceNumberDay = '';
            if (!this.createInfoModel?.bgCategoryId) return;
            const params = {
                bgCategoryId: this.createInfoModel.bgCategoryId,
                needQueryField: { requireDefaultGuaranteePeriod: true },
                brandId: this.brandId,
                importFlag: this.importFlag,
                extAttrList: this.form.skuBaseAttributes || [],
            };
            const res = await this.$service.queryBgCategoryConfig(params);
            if (res.flowSpecByCategoryInfo) {
                this.flowSpecByCategoryInfo = res.flowSpecByCategoryInfo;
                if (!this.form.guaranteePeriod?.length) this.form.guaranteePeriod = [initBaozhiqi(this.flowSpecByCategoryInfo)];
                const { guaranteePeriod, guaranteePeriodType } = res.flowSpecByCategoryInfo;
                const num = guaranteePeriodType ? guaranteePeriod : '';
                const day = this.cptTime(guaranteePeriodType) || '';
                this.guaranteePeriodAdviceNumberDay = num + day;
                // 赋值默认保质期
                if (!this.isFirstEnforce) {
                    this.form.guaranteePeriod = (this.form?.guaranteePeriod || []).map((item) => ({
                        ...item,
                        guaranteePeriod: guaranteePeriod || item.guaranteePeriod,
                        guaranteePeriodType: guaranteePeriodType || item.guaranteePeriodType,
                        guaranteePeriodChangeReason: '',
                    }));
                } else {
                    this.isFirstEnforce = false;
                }
            }
        }, 500),
        // 城市有差异删除条件
        canDeleteCondition(item, index, list) {
            // return index > 0 && (!item.existedIds || !item.existedIds.length);
            return (list && list.length > 1) && (!item.existedIds || !item.existedIds.length);
        },
        // 清理多余数据，保证参数准确
        cleanProductInfo() {
            // 原料
            // 清理【重量】
            if (this.isMaterial) {
                this.form.weight = null;
            }
        },
        /**
         * 处理特殊校验：
         * 1. 城市有差异字段，所有城市都必须勾选
         * 2. 箱规的quantity，需要做唯一校验
         */
        specialValid() {
            let validResult = true;
            // 1
            const validMap = {
                cityBoxProps: '箱规',
                guaranteePeriod: '保质期',
            };
            Object.keys(validMap).some((prop) => {
                // 可以新提报的城市
                const publicIds = this.publicCityIds;
                // 字段中，已选的新提报的城市合集
                const curNewCityIds = (this.form[prop] || []).map((item) => item.cityIds).flat();
                // 取差集，判断是否都已勾选
                if (window._.xor(publicIds, curNewCityIds).length) {
                    validResult = false;
                    this.$message.error(`【${validMap[prop]}】的城市未配置全`);
                    return true;
                }
                return false;
            });
            // 2
            const boxUniqueArr = [];
            const boxUniqueValid = this.form.cityBoxProps.some((item) => {
                const quantity = item.boxProps.boxQuantity;
                if (boxUniqueArr.includes(quantity)) {
                    return true;
                } else {
                    boxUniqueArr.push(quantity);
                }
                return false;
            });
            if (boxUniqueValid) {
                validResult = false;
                this.$message.error('箱规值唯一，不能重复');
            }
            return validResult;
        },
        // 外部调用
        async validate() {
            let validResult = false;
            try {
                const validJobs = [this.$refs.noDiffForm.getVM().validate(), this.$refs.diffForm.validate(), this.$refs.codeList._validate()];
                if (!this.isMaterial) validJobs.push(this.$refs.sgInfoRef.validate()); // 如果非原料添加闪购信息验证
                const valids = await Promise.all(validJobs);
                const specialValid = await this.specialValid();
                const extValid = this.$refs.extAttrs.validate();
                valids.push(extValid, specialValid);
                validResult = valids.every((valid) => valid === true);
            } catch (error) {
                // pass
                console.warn(error);
                const errDom = document.querySelector('.is-error');
                if (errDom) {
                    errDom.scrollIntoView();
                }
            }
            return validResult;
        },
        clearValid() {
            if (!this.$refs.noDiffForm) return;
            const noDiffForm = this.$refs.noDiffForm.getVM();
            noDiffForm.clearValidate();
        },
    },
};
</script>

<style lang="scss" scoped>
.product-base-info {
    /deep/ .xx-categoryselect {
        width: 100%;
    }
    /deep/ .el-select {
        width: 460px !important;
    }
    /deep/ .el-input-number{
        width: 66%;
    }
}
.large-w {
    width: 300px !important;
}
.common-w {
    width: 180px !important;
}
.textarea-w {
    width: 300px !important;
}
.mg-t-b-10 {
    margin: 10px 0;
}
.mg-b-20 {
    margin-bottom: 20px;
}
.small-w {
    width: 80px !important;
}
// .max-width {
//     max-width: 1200px;
// }
.max-width-750 {
    max-width: 750px;
}
.w-full {
    width: 100%;
}
.product-size {
    display: flex;
}
.text-info {
    color: #95989E;
    font-size: 14px;
}
</style>
